import { ProductoTerminadoDTO } from "./ProductoTerminadoDTO"

export interface EmailModel
{
    asunto: string,
    to: string,
    ccsAddreses: Array<string>,
    texto: string
}

export function GetVoidEmailModel():EmailModel
{
    return {
        asunto: '',
        to: '',
        ccsAddreses: [],
        texto: ''
    }
}

export interface ResponseMailService
{
    respuesta:string
}

export interface EmailProductoCreado 
{
    asunto: string,
    to: string,
    producto: ProductoTerminadoDTO,
}

export function setEmailProductoCreado(asunto: string,to:string,producto:ProductoTerminadoDTO):EmailProductoCreado 
{
    return{
        asunto: asunto,
        to: to,
        producto: producto,
    }
}